module.exports = __webpack_public_path__ + "img/pr_img3.b80b8227.png";